import { last } from 'ramda';

import { EStepCode } from '../../types/requestFormSchema';
import { TThunkAction } from '../../types/redux';
import { updateLegalCheck } from './updateLegalCheck';
import { setCurrentStep } from './actionts';
import { TRequestFormCallbackProps } from '../../types/requestForm';

export const handleNextStep =
  (props: TRequestFormCallbackProps): TThunkAction<void | Promise<void>> =>
  async dispatch => {
    const updatePromise = dispatch(
      updateLegalCheck({
        fromStep: props.fromStep.code as EStepCode,
        formValue: props.formValue,
      }),
    );

    /** Если есть кнопка сабмита на шаге - ждем промис, что бы показать процесс отправки запроса **/
    if (props.fromStep.question.actions) {
      await updatePromise;
    }

    const nextStep = last(props.stepsHistory);
    if (nextStep) {
      dispatch(setCurrentStep(nextStep.code as EStepCode));
    }
  };
